var map = {
	"./fastqrgenerator.com/content-types/vcard": 39258,
	"./onlineqrcode.com/content-types/vcard": 35615,
	"./qrcreator.com/content-types/vcard": 13498,
	"./qrnow.com/content-types/vcard": 21880
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12530;